import React, { useState } from 'react';
import { Trophy } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';
import { SectionHeader } from './SectionHeader';
import { PostDetailModal } from './PostDetailModal';

// Top Performing Posts Component
export function TopPerformingPosts({ topPerformingPosts, dateRangeLabel, channelType = 'public' }) {
  const [selectedPost, setSelectedPost] = useState(null);
  
  return (
    <>
      <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))] rounded-xl overflow-hidden">
        <SectionHeader icon={Trophy} title="Top Performing Posts" subtitle={`Best ${topPerformingPosts.length} posts • ${dateRangeLabel}`} />
        
        <div className="p-5">
          {topPerformingPosts.length > 0 ? (
            <div className="space-y-3">
              {topPerformingPosts.map((post, idx) => (
                <div 
                  key={idx} 
                  onClick={() => setSelectedPost(post)}
                  className="flex items-center gap-3 p-3 bg-[hsl(var(--surface-elevated))] rounded-lg border border-[hsl(var(--border))] hover:border-[#F59E0B]/30 transition-colors cursor-pointer"
                >
                  {/* Rank Badge */}
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 font-bold text-sm ${
                    idx === 0 ? 'bg-[#F59E0B]/20 text-[#F59E0B]' : 
                    idx === 1 ? 'bg-[#9CA3AF]/20 text-[#9CA3AF]' : 
                    idx === 2 ? 'bg-[#CD7F32]/20 text-[#CD7F32]' : 
                    'bg-[hsl(var(--border))] text-[#6B7280]'
                  }`}>
                    #{idx + 1}
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-white truncate">
                      {post.text || post.caption || (post.has_photo ? '📷 Photo post' : post.has_video ? '🎬 Video post' : 'Post')}
                    </p>
                    <p className="text-[10px] text-[#6B7280]">
                      {post.date ? format(new Date(post.date), 'dd MMM yyyy, HH:mm') : ''}
                    </p>
                  </div>
                  
                  {/* Stats */}
                  <div className="flex items-center gap-4 shrink-0">
                    <div className="text-center">
                      <p className="text-sm font-semibold text-white">{(post.views || 0).toLocaleString()}</p>
                      <p className="text-[9px] text-[#6B7280]">views</p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-semibold text-[#E63946]">{post.reactionCount}</p>
                      <p className="text-[9px] text-[#6B7280]">reactions</p>
                    </div>
                    <div className="text-center">
                      <Badge className={`text-[9px] ${post.err >= 2 ? 'bg-[#10B981]/20 text-[#10B981]' : 'bg-[#6B7280]/20 text-[#6B7280]'}`}>
                        {post.err.toFixed(1)}%
                      </Badge>
                      <p className="text-[9px] text-[#6B7280]">ERR</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-[#6B7280]">
              <Trophy size={32} className="mx-auto mb-2 opacity-50" />
              <p className="text-sm">No posts in selected period</p>
            </div>
          )}
        </div>
      </div>
      
      {/* Post Detail Modal */}
      <PostDetailModal 
        selectedPost={selectedPost} 
        onClose={() => setSelectedPost(null)} 
        channelType={channelType}
      />
    </>
  );
}

export default TopPerformingPosts;
